import { render } from "./EditingSectionExternal.vue?vue&type=template&id=8700137e"
import script from "./EditingSectionExternal.vue?vue&type=script&lang=js"
export * from "./EditingSectionExternal.vue?vue&type=script&lang=js"
script.render = render

export default script